
import { CONSTANTS } from "../../constants";

export default {
  name: "ChatbotProductPage",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.CHATBOT_BANNER_DETAILS,
    CLIENT_LOGOS: CONSTANTS.CLIENT_LOGOS,
    CLIENT_LOGOS_WITH_TEXT: CONSTANTS.CLIENT_LOGOS_WITH_TEXT,
    REVIEWS: CONSTANTS.REVIEWS,
    features: [
      {
        name: "Conversational Skills",
        description:
          "Our Chatbot is designed to understand natural language and provide personalized responses to your customers' queries. Whether it's a simple question about your products or a complex issue that requires technical expertise, our chatbot is equipped to handle it all.",
        imageName: "Conversational Skills.png",
      },
      {
        name: "Human Handover",
        description:
          "We understand that there are times when a human touch is necessary. That's why we have incorporated a human handover feature into our chatbot. This feature allows your customers to seamlessly transition from the chatbot to a human agent without losing the context of the conversation.",
        imageName: "Human Handover.png",
      },
      {
        name: "Easy Integration",
        description:
          "Our Chatbot is easy to integrate into your existing systems and can be deployed on multiple channels, including your website, social media, and messaging platforms.",
        imageName: "Easy Integration.png",
      },
    ],
  }),
  mounted() {
    if (window.innerWidth > 600)
      this.CLIENT_LOGOS = this.CLIENT_LOGOS_WITH_TEXT;
  },
  head() {
    return {
      title: "Chatbot by AiBuddha",
      description:
        "Connect with your customer where it matters the most to them. Let our AI take care of the heavy lifting while people work on planning growth strategies.",
    };
  },
};
